import styled from "styled-components";

import { mq } from "../../../styles/canonical/breakpoints";

/* Auditoria mobile 2026-09-24: com seis abas em 343px a régua estourava
   (456px, overflow visible) e "Exportações" ficava fora da tela sem como
   chegar nela. Agora rola no eixo X com snap; a aba não quebra linha. */
export const AbasWrap = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  /* Degradê na borda direita: sinal de que há mais abas (S2, Sobras). */
  @media ${mq.mobile} {
    -webkit-mask-image: linear-gradient(90deg, #000 calc(100% - 32px), transparent);
    mask-image: linear-gradient(90deg, #000 calc(100% - 32px), transparent);
  }
`;

export const AbaBtn = styled.button`
  border: 0;
  background: transparent;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  color: ${({ $on }) => ($on ? "var(--ink-1)" : "var(--ink-3)")};
  border-bottom: 2px solid ${({ $on }) => ($on ? "var(--primary)" : "transparent")};
  font-weight: ${({ $on }) => ($on ? 600 : 400)};
  white-space: nowrap;
  flex: 0 0 auto;
  scroll-snap-align: start;

  @media ${mq.mobile} {
    min-height: 44px;
    font-size: 13px;
  }
`;

export const Medida = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const Acoes = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

/* Barra de ações da lista (importar / exportar / excluir): no celular os
   botões viram alvos de 40px e dividem a linha. */
export const AcoesLista = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  &:empty { display: none; }
  @media ${mq.mobile} {
    > button { flex: 1 1 auto; justify-content: center; min-height: 40px; }
  }
`;

/* Filtros da lista: busca + selects. Larguras do desktop moram aqui (não
   inline) para o celular poder empilhar tudo na largura toda com 40px. */
export const FiltrosLinha = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  > input { min-width: 220px; }
  > select.material { max-width: 260px; }
  @media ${mq.mobile} {
    > input, > select { flex: 1 1 100%; min-width: 0; max-width: none; min-height: 40px; }
  }
`;
